<template>
  <transition appear name="sidenav">
    <div v-if="$beet.isReady && $store.state.side_nav_opened" class="sidenav">
      <nav class="sidenav__content">
        <template v-if="!$mq.smPlus">
          <RouterLink v-reveal="{ delay: 275 }" :to="{ name: 'program' }" class="sidenav__title">
            À propos
          </RouterLink>

          <RouterLink v-reveal="{ delay: 275 }" :to="{ name: 'support' }" class="sidenav__title">
            Soutien
          </RouterLink>
        </template>
        <div class="row -mobile -align-center -spread sidenav__row" style="width: 100%">
          <RouterLink v-reveal="{ delay: 275 }" :to="{ name: 'themes' }" class="sidenav__title">
            Boîte à outils
          </RouterLink>

          <RouterLink
            v-reveal="{ delay: 375 }"
            :to="{ name: 'themes' }"
            class="sidenav__button button -link -flat -corner-right"
            >Voir tout
          </RouterLink>
        </div>

        <h2 v-reveal="{ delay: 400 }" class="section__title sidenav__subtitle">
          Thématiques en vedette
        </h2>

        <menu class="sidenav__list">
          <RouterLink
            v-for="(theme, idx) in themes"
            :key="theme.id"
            v-reveal="{ delay: 325 + 25 * idx }"
            :to="{ name: 'theme', params: { themeSlug: theme.slug } }"
            class="sidenav__item -leafy"
          >
            <Icon id="leaves-dark" class="sidenav__leaves" />
            {{ theme.title }}
          </RouterLink>
        </menu>

        <RouterLink v-reveal="{ delay: 375 }" :to="{ name: 'projects' }" class="sidenav__title">
          Répertoire de projets
        </RouterLink>

        <RouterLink
          v-reveal="{ delay: 325 }"
          :to="{ name: 'trainings' }"
          class="sidenav__title -training"
        >
          Formations & Événements
        </RouterLink>

        <RouterLink
          v-if="$mq.mdMin"
          v-reveal="{ delay: 325 }"
          :to="{ name: 'involve' }"
          class="sidenav__title"
        >
          S’impliquer
        </RouterLink>
      </nav>

      <header class="sidenav__header">
        <menu class="sidenav__menu" v-if="$mq.smPlus">
          <RouterLink v-reveal="{ delay: 175 }" class="sidenav__link" :to="{ name: 'program' }">
            <Icon id="leaf" class="sidenav__link-leaf" />
            À propos
          </RouterLink>

          <RouterLink v-reveal="{ delay: 225 }" class="sidenav__link" :to="{ name: 'support' }">
            <Icon id="leaf" class="sidenav__link-leaf" />
            Soutien
          </RouterLink>

          <span v-reveal="{ delay: 275 }">
            <RouterLink
              class="sidenav__link button -link -flat -secondary -alt -corner-right"
              :to="{ name: 'involve' }"
              >S'impliquer
            </RouterLink>
          </span>
          <!-- <GoogleSearchBar v-show="!$mq.smPlus" /> -->
        </menu>
        <img
          src="@/assets/images/logoDark.svg"
          width="91"
          height="42"
          class="sidenav__header-logo"
          alt="logo"
          v-reveal
        />

        <button
          v-reveal="{ delay: 325 }"
          class="burger -close"
          @click="$store.dispatch('closeSideNav')"
        >
          <div style="display: flex; align-items: flex-end">
            <div style="font-size: 1rem; margin-bottom: -0.15rem; margin-right: 0.25rem">✕</div>
            <div>
              <span class="burger__line" />
              <span class="burger__line -middle" />
            </div>
          </div>

          <span class="burger__line" />
        </button>
      </header>
    </div>
  </transition>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import GoogleSearchBar from '@/components/googleServices/GoogleSearchBar.vue'

export default {
  name: 'SideNav',
  components: { Icon, GoogleSearchBar },
  computed: {
    themes() {
      return Object.values(this.$beet.themes)
        .slice(0, 5)
        .toSorted((a, b) => b.title.length - a.title.length)
    },
  },
  watch: {
    '$store.state.side_nav_opened'(isVisible) {
      if (isVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    '$route.path'() {
      this.$store.dispatch('closeSideNav')
    },
  },
}
</script>
